import React from 'react';
import { bindActionCreators} from 'redux';
import { connect } from 'react-redux';
import {Button} from 'semantic-ui-react';
import PropTypes from 'prop-types';

class PrimaryButton extends React.PureComponent {
    //access router
    //this.props.history.push('/dashboard')
    
    render() {
        const {size, float, label, preference, onClick, loading} = this.props;
        return (
            <Button
                size={size}
                color={preference.t_primary_btn ? preference.t_primary_btn : 'teal'}
                floated={float ? float : 'left'}
                onClick={() => {
                    onClick()
                }}
            disabled={loading}
                loading={loading}
            >{label}</Button>
        )
    }
}

PrimaryButton.propTypes = {
    size: PropTypes.string.isRequired,
    float: PropTypes.any,
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired
};

function mapStateToProps(state) {
    return {
        preference: state.system.preference
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(PrimaryButton)